import React from "react";
import styled from "styled-components";
import { WarningIcon } from "./WarningIcon";

export interface ErrorMessageProps {
  message: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = (props) => {
  return (
    <StyledErrorMessage>
      <WarningIcon />

      <p>{props.message}</p>
    </StyledErrorMessage>
  );
};

const StyledErrorMessage = styled.div`
  background: rgba(190, 58, 58, 0.54);
  border-radius: 3px;
  width: 100%;
  display: flex;
  padding: 12px 24px;

  svg {
    flex-shrink: 0;
    margin: 0 14px 0 0;
    transform: translateY(2px);
  }

  p {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 21px;
    letter-spacing: 0.4px;
    color: #ffffff;
  }
`;
